module.exports = __webpack_public_path__ + "static/media/coduo-logo-white.74456288.png";